/*eslint-disable*/
import React from "react";
import ReactDOM from "react-dom";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { Link, NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import AddAlert from "@material-ui/icons/AddAlert";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";

import { FormErrors } from "../../../components/Login/FormErrors";
// import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import {
  Button,
  FormGroup,
  FormControl,
  FormControlLabel,
  InputLabel,
  Link as MaterialLink,
  CircularProgress,
  Box,
  TextField,
  Avatar,
  Checkbox,
  LinearProgress,
  Tooltip,
} from "@material-ui/core";

import { providerBaseRoutes } from "base-routes";
import { userService } from "_services/user.service";

import {
  EMAIL_REGEX,
  ONLY_NUMBER_REGEX,
  ONLY_AlPHABETS_REGEX,
  URL_PATTERN,
  MAX_INPUT_LENGTH_LONG_TEXT,
  ALLOWED_LOGO_EXTENSIONS,
  ALLOWED_LOGO_SIZE,
  ALLOWED_GALLERY_EXTENSIONS,
  ALLOWED_GALLERY_SIZE,
  MAX_GALLERY_IMAGES,
  ALLOWED_BROCHURE_EXTENSIONS,
  ALLOWED_BROCHURE_SIZE,
} from "__helpers/constants";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DeleteIcon from "@material-ui/icons/Delete";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { generalMimeAuthTokenHeader } from "__helpers/auth-header";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment-timezone";
import enMsg from "__helpers/locale/en/en";

import { apiPath } from "api";

import { USER_INFO, ZIP_CODE_LENGTH, DIGIT_ONLY } from "__helpers/constants";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import { basePath } from "base-routes";
const mat_select = "material-select disabled-dropdown-black";
const cust_label = "custom-label";
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFF",
    },
  },
  cardTitleWhite: {
    color: "#FFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  disabledDropdownBlack: {
    color: "#000 !important",
  },
};

class OrganizationDetails extends React.Component {
  maxDate = new Date();
  minDate = new Date();
  constructor(props) {
    super(props);
    this.dateUtility = new DateFnsUtils();
    let userInfo = JSON.parse(localStorage.getItem(USER_INFO));
    this.addressStreetInputRef = React.createRef();
    this.logoInputRef = React.createRef();
    this.picturesInputRef = React.createRef();
    this.brochureInputRef = React.createRef();
    this.state = {
      organizationalDetails: "",
      stateList: "",
      addressStreet: "",
      addressSuite: "",
      city: "",
      dateEstablishment: null,
      email: "",
      fax: "",
      orgName: "",
      phone: "",
      state: "",
      websiteUrl: "",
      zipcode: "",
      primaryEmail: "",
      primaryFirstName: "",
      primaryLastName: "",
      primaryPhone: "",
      userid: "",
      providerId: "",
      oldUserId: "",
      providerAboutUs: "",
      latitude: "",
      longitude: "",
      isImported: false,
      isVerified: false,
      // Organization media state
      organizationLogo: null,
      organizationLogoUrl: null,
      organizationBrochure: null,
      organizationBrochureUrl: null,
      organizationPictures: [],
      selectedPictureIds: [],
      logoUploading: false,
      picturesUploading: false,
      brochureUploading: false,
      formErrors: {
        addressStreet: "",
        addressSuite: "",
        city: "",
        dateEstablishment: "",
        email: "",
        fax: "",
        orgName: "",
        phone: "",
        state: "",
        websiteUrl: "",
        zipcode: "",
        primaryEmail: "",
        primaryFirstName: "",
        primaryLastName: "",
        primaryPhone: "",
        userid: "",
        providerAboutUs: "",
        latitude: "",
        longitude: "",
      },
      addressStreetValid: false,
      addressSuiteValid: true,
      cityValid: false,
      dateEstablishmentValid: false,
      emailValid: false,
      faxValid: true,
      orgNameValid: false,
      phoneValid: false,
      stateValid: false,
      websiteUrlValid: true,
      zipcodeValid: false,
      primaryEmailValid: true,
      primaryFirstNameValid: false,
      primaryLastNameValid: false,
      primaryPhoneValid: false,
      useridValid: true,
      providerAboutUsValid: true,
      remainingCount: MAX_INPUT_LENGTH_LONG_TEXT,
      userInfo: userInfo,
      latitudeValid: false,
      longitudeValid: false,
    };
  }
  componentDidMount() {
    this.getStateList();
    let userInfo = JSON.parse(localStorage.getItem(USER_INFO));
    this.setState(
      {
        providerId: userInfo.provider.id,
      },
      () => {
        this.fetchOrganizationalDetail();
      }
    );

    const autocomplete = new window.google.maps.places.Autocomplete(
      this.addressStreetInputRef.current
    );
    // Add event listener for place selection
    autocomplete.addListener("place_changed", () => {
      this.handlePlaceSelection(autocomplete);
    });

    // Store the Autocomplete object in the component's state
    this.setState({ addressAutocomplete: autocomplete });
  }
  handlePlaceSelection = (autocomplete) => {
    // Get the selected place details from the Autocomplete object
    const selectedPlace = autocomplete.getPlace();

    if (selectedPlace && selectedPlace.formatted_address) {
      this.setState({
        city: "",
        zipcode: "",
        latitude: "",
        longitude: "",
      });
      // Extract the address components from the selected place
      const addressStreet = selectedPlace.formatted_address;
      const city = selectedPlace.address_components.find((component) =>
        component.types.includes("locality")
      )?.long_name;
      const state = selectedPlace.address_components.find((component) =>
        component.types.includes("administrative_area_level_1")
      )?.short_name;
      const zipcode = selectedPlace.address_components.find((component) =>
        component.types.includes("postal_code")
      )?.long_name;
      const latitude = selectedPlace.geometry.location.lat();
      const longitude = selectedPlace.geometry.location.lng();
      // console.log(selectedPlace.geometry.location);
      // Update the state with the selected address components

      this.setState({
        addressStreet: addressStreet,
        city: city,
        state: state,
        zipcode: zipcode,
        latitude: latitude,
        longitude: longitude,
      });
      if (addressStreet) this.validateField("addressStreet", addressStreet);
      if (city) this.validateField("city", city);
      if (state) this.validateField("state", state);
      if (zipcode) this.validateField("zipcode", zipcode);
      if (latitude) this.validateField("latitude", latitude);
      if (longitude) this.validateField("longitude", longitude);
    }
  };
  getStateList = async () => {
    let stateList = await userService.getStateList();
    this.setState({
      stateList: stateList,
    });
  };
  handleZipCodeInput = (e) => {
    const value = e.target.value;
    if (value.length > ZIP_CODE_LENGTH) {
      return true;
    }
    if (value.trim() == "" || value.match(DIGIT_ONLY)) {
      this.setState({ zipcode: value }, () => {
        this.validateField("zipcode", value);
      });
    }
  };
  handleChangeInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    let remainingCount = this.state.remainingCount;
    if (name == "providerAboutUs") {
      let aboutUsCount = value.length;
      let remainingCount = MAX_INPUT_LENGTH_LONG_TEXT - aboutUsCount;
      this.setState({
        remainingCount: remainingCount,
      });
    }
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value);
      }
    );
  };
  validateField = (fieldName, fieldValue) => {
    let fieldValidationErrors = this.state.formErrors;
    let addressStreetValid = this.state.addressStreetValid;
    let addressSuiteValid = this.state.addressSuiteValid;
    let cityValid = this.state.cityValid;
    let dateEstablishmentValid = this.state.dateEstablishmentValid;
    let emailValid = this.state.emailValid;
    let faxValid = this.state.faxValid;
    let orgNameValid = this.state.orgNameValid;
    let phoneValid = this.state.phoneValid;
    let stateValid = this.state.stateValid;
    let websiteUrlValid = this.state.websiteUrlValid;
    let zipcodeValid = this.state.zipcodeValid;
    let primaryEmailValid = this.state.primaryEmailValid;
    let primaryFirstNameValid = this.state.primaryFirstNameValid;
    let primaryLastNameValid = this.state.primaryLastNameValid;
    let primaryPhoneValid = this.state.primaryPhoneValid;
    let useridValid = this.state.useridValid;
    let latitudeValid = this.state.latitudeValid;
    let longitudeValid = this.state.longitudeValid;
    switch (fieldName) {
      case "orgName":
        if (fieldValue.trim().length == 0) {
          orgNameValid = false;
          fieldValidationErrors.orgName = "Organization name is required";
        } else {
          orgNameValid = true;
          fieldValidationErrors.orgName = "";
        }
        break;
      case "addressStreet":
        if (fieldValue.trim().length == 0) {
          addressStreetValid = false;
          fieldValidationErrors.addressStreet = "Address street is required";
        } else {
          addressStreetValid = true;
          fieldValidationErrors.addressStreet = "";
        }
        break;
      case "addressSuite":
        if (fieldValue.trim().length == 0) {
          addressSuiteValid = true;
          fieldValidationErrors.addressSuite = "";
        } else {
          addressSuiteValid = true;
          fieldValidationErrors.addressSuite = "";
        }
        break;
      case "city":
        if (fieldValue.trim().length == 0) {
          cityValid = false;
          fieldValidationErrors.city = "City is required";
        } else {
          cityValid = true;
          fieldValidationErrors.city = "";
        }
        break;
      case "primaryFirstName":
        if (fieldValue.trim().length == 0) {
          primaryFirstNameValid = false;
          fieldValidationErrors.primaryFirstName = "First name is required";
        } else if (!fieldValue.trim().match(ONLY_AlPHABETS_REGEX)) {
          primaryFirstNameValid = false;
          fieldValidationErrors.primaryFirstName = "Only alphabets are allowed";
        } else {
          primaryFirstNameValid = true;
          fieldValidationErrors.primaryFirstName = "";
        }
        break;
      case "primaryLastName":
        if (fieldValue.trim().length == 0) {
          primaryLastNameValid = false;
          fieldValidationErrors.primaryLastName = "Last name is required";
        } else if (!fieldValue.trim().match(ONLY_AlPHABETS_REGEX)) {
          primaryLastNameValid = false;
          fieldValidationErrors.primaryLastName = "Only alphabets are allowed";
        } else {
          primaryLastNameValid = true;
          fieldValidationErrors.primaryLastName = "";
        }
        break;
      case "dateEstablishment":
        if (!fieldValue) {
          dateEstablishmentValid = false;
          fieldValidationErrors.dateEstablishment =
            "Date of establishment is required";
        } else {
          dateEstablishmentValid = true;
          fieldValidationErrors.dateEstablishment = "";
        }
        break;
      case "fax":
        let faxErrMsg = "";
        if (fieldValue.trim().length == 0) {
          faxValid = true;
          faxErrMsg = "";
        } else if (
          isNaN(fieldValue.trim()) ||
          !ONLY_NUMBER_REGEX.test(fieldValue)
        ) {
          faxValid = false;
          faxErrMsg = "Invalid number";
        } else if (fieldValue.trim().length != 10) {
          faxValid = false;
          faxErrMsg = "Fax should have only 10 digits";
        } else {
          faxValid = true;
        }
        fieldValidationErrors.fax = faxValid ? "" : faxErrMsg;
        break;
      case "userid":
        if (fieldValue.trim().length == 0) {
          useridValid = false;
          fieldValidationErrors.userid = "User login id is required";
        } else if (!fieldValue.trim().match(ONLY_AlPHABETS_REGEX)) {
          useridValid = false;
          fieldValidationErrors.userid = "Only alphabets are allowed";
        } else {
          useridValid = true;
          fieldValidationErrors.userid = "";
        }
        break;
      case "state":
        if (fieldValue == "") {
          stateValid = false;
          fieldValidationErrors.state = "State is required";
        } else {
          stateValid = true;
          fieldValidationErrors.state = "";
        }
        break;
      case "websiteUrl":
        if (fieldValue.trim().length == 0) {
          websiteUrlValid = true;
          fieldValidationErrors.websiteUrl = "";
        } else if (
          fieldValue.trim().length &&
          !fieldValue.trim().match(URL_PATTERN)
        ) {
          websiteUrlValid = false;
          fieldValidationErrors.websiteUrl = "Invalid url";
        } else {
          websiteUrlValid = true;
          fieldValidationErrors.websiteUrl = "";
        }
        break;
      case "zipcode":
        if (fieldValue.trim().length == 0) {
          zipcodeValid = false;
          fieldValidationErrors.zipcode = "Zipcode is required";
        } else {
          zipcodeValid = true;
          fieldValidationErrors.zipcode = "";
        }
        break;
      case "email":
        if (fieldValue.trim().length == 0) {
          emailValid = false;
          fieldValidationErrors.email = "Email is required";
        } else if (!fieldValue.trim().match(EMAIL_REGEX)) {
          emailValid = false;
          fieldValidationErrors.email = "Invalid email";
        } else {
          emailValid = true;
          fieldValidationErrors.email = "";
        }
        break;
      case "phone":
        let errMsg = "";
        if (fieldValue.trim().length == 0) {
          phoneValid = false;
          errMsg = "Phone number is required";
        } else if (
          isNaN(fieldValue.trim()) ||
          !ONLY_NUMBER_REGEX.test(fieldValue)
        ) {
          phoneValid = false;
          errMsg = "Invalid number";
        } else if (fieldValue.trim().length != 10) {
          phoneValid = false;
          errMsg = enMsg.phoneNumberDigit;
        } else {
          phoneValid = true;
        }
        fieldValidationErrors.phone = phoneValid ? "" : errMsg;
        break;
      case "primaryEmail":
        if (fieldValue.trim().length == 0) {
          primaryEmailValid = true;
          fieldValidationErrors.primaryEmail = "";
        } else if (!fieldValue.trim().match(EMAIL_REGEX)) {
          primaryEmailValid = false;
          fieldValidationErrors.primaryEmail = "Invalid email";
        } else {
          primaryEmailValid = true;
          fieldValidationErrors.primaryEmail = "";
        }
        break;
      case "primaryPhone":
        let perrMsg = "";
        if (fieldValue.trim().length == 0) {
          primaryPhoneValid = false;
          perrMsg = "Phone number is required";
        } else if (
          isNaN(fieldValue.trim()) ||
          !ONLY_NUMBER_REGEX.test(fieldValue)
        ) {
          primaryPhoneValid = false;
          perrMsg = "Invalid number";
        } else if (fieldValue.trim().length != 10) {
          primaryPhoneValid = false;
          perrMsg = enMsg.phoneNumberDigit;
        } else {
          primaryPhoneValid = true;
        }
        fieldValidationErrors.primaryPhone = primaryPhoneValid ? "" : perrMsg;
        break;
      case "latitude":
        if (fieldValue == "") {
          latitudeValid = true;
          fieldValidationErrors.latitude = "Latitude is required";
        } else {
          latitudeValid = true;
          fieldValidationErrors.latitude = "";
        }
        break;
      case "longitude":
        if (fieldValue == "") {
          longitudeValid = true;
          fieldValidationErrors.longitude = "Longitude is required";
        } else {
          longitudeValid = true;
          fieldValidationErrors.longitude = "";
        }
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        addressStreetValid: addressStreetValid,
        addressSuiteValid: addressSuiteValid,
        cityValid: cityValid,
        dateEstablishmentValid: dateEstablishmentValid,
        emailValid: emailValid,
        faxValid: faxValid,
        orgNameValid: orgNameValid,
        phoneValid: phoneValid,
        stateValid: stateValid,
        websiteUrlValid: websiteUrlValid,
        zipcodeValid: zipcodeValid,
        primaryEmailValid: primaryEmailValid,
        primaryFirstNameValid: primaryFirstNameValid,
        primaryLastNameValid: primaryLastNameValid,
        primaryPhoneValid: primaryPhoneValid,
        useridValid: useridValid,
        latitudeValid: latitudeValid,
        longitudeValid: longitudeValid,
      },
      this.validateForm
    );
  };

  validateForm() {
    return (
      this.state.addressStreetValid &&
      this.state.addressSuiteValid &&
      this.state.cityValid &&
      this.state.dateEstablishmentValid &&
      this.state.emailValid &&
      this.state.faxValid &&
      this.state.orgNameValid &&
      this.state.phoneValid &&
      this.state.stateValid &&
      this.state.websiteUrlValid &&
      this.state.zipcodeValid &&
      this.state.primaryPhoneValid
    );
  }
  handleEstDate = (value) => {
    let dateEstablishment = true;
    if (value == null || !this.dateUtility.isValid(value)) {
      dateEstablishment = false;
    }
    this.setState(
      {
        dateEstablishment: value,
        dateEstablishmentValid: dateEstablishment,
      },
      () => {
        this.validateField("dateEstablishment", value);
      }
    );
  };
  handleEstDateError = (error, value) => {
    this.setState({
      dateEstablishmentValid:
        error || value == "" || value == null ? false : true,
    });
  };
  handleVerifiedChange = () => {
    this.setState((prevState) => ({
      isVerified: !prevState.isVerified,
    }));
  };
  handleSubmit = (event) => {
    event.preventDefault();
    let data = {
      addressStreet: this.state.addressStreet,
      addressSuite: this.state.addressSuite,
      city: this.state.city,
      dateEstablishment: this.state.dateEstablishment,
      email: this.state.email,
      fax: this.state.fax,
      orgName: this.state.orgName,
      phone: this.state.phone,
      state: this.state.state,
      websiteUrl: this.state.websiteUrl,
      zipcode: this.state.zipcode,
      primaryEmail: this.state.primaryEmail,
      primaryFirstName: this.state.primaryFirstName,
      primaryLastName: this.state.primaryLastName,
      primaryPhone: this.state.primaryPhone,
      providerId: this.state.providerId,
      providerAboutUs: this.state.providerAboutUs,
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      organizationLogo: this.state.organizationLogoUrl,
      organizationLogoBase64: this.state.organizationLogo,
      organizationBrochure: this.state.organizationBrochureUrl,
      organizationBrochureBase64: this.state.organizationBrochure,
      isVerified: this.state.isVerified,
    };
    if (this.state.oldUserId != this.state.userid) {
      // data.userLoginId = this.state.userid;
    }
    this.saveOrganizationalData(data);
  };
  saveOrganizationalData = async (data) => {
    this.setState({ loading: true });
    let showNotification = {};
    try {
      const response = await fetch(apiPath.saveOrganizationDetail, {
        method: "POST",
        headers: generalAuthTokenHeader(),
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status === 400) {
            showNotification = {
              title: "Provider User",
              message: enMsg.badResponseFromServer,
              type: "danger",
            };
          } else if (response.ok) {
          } else {
            showNotification = {
              title: "Details",
              message: enMsg.badResponseFromServer,
              type: "danger",
            };
          }
          return response.json();
        })
        .then((data) => {
          if (data.status == "400" && data.message == "error.userManagement") {
            modalCloseStatus = 0;
            showNotification = {
              title: "Details",
              message: "User login id is already exist.",
              type: "danger",
            };
          } else if (data.providerId) {
            showNotification = {
              title: "Details",
              message: "Organizational details saved successfully",
              type: "success",
            };
            window.location.replace(
              basePath + providerBaseRoutes.profile.path + "?tab=personal"
            );
            return true;
          }
        })
        .catch((error) => {
          showNotification = {
            title: "Details",
            message: enMsg.networkFailedError,
            type: "danger",
          };
          return response;
        });
    } catch (error) {
      showNotification = {
        title: "Details",
        message: enMsg.networkFailedError,
        type: "danger",
      };
    }
    userService.showNotification(showNotification);
    this.setState({ loading: false });
  };
  fetchOrganizationalDetail = () => {
    const response = fetch(
      apiPath.saveOrganizationDetail + "?id=" + this.state.providerId,
      {
        method: "GET",
        headers: generalAuthTokenHeader(),
      }
    )
      .then((response) => {
        if (response.status === 400) {
        } else if (response.ok) {
        } else {
        }
        return response.json();
      })
      .then((data) => {
        if (data.providerId) {
          let remainingCount = this.state.remainingCount;
          if (data.providerAboutUs) {
            let aboutUsCount = data.providerAboutUs.length;
            let remainingCount = MAX_INPUT_LENGTH_LONG_TEXT - aboutUsCount;
            this.setState({
              remainingCount: remainingCount,
            });
          }
          this.setState({
            addressStreet: data.addressStreet,
            addressSuite: data.addressSuite,
            city: data.city,
            dateEstablishment: data.dateEstablishment,
            email: data.email,
            fax: data.fax,
            orgName: data.orgName
              ? data.orgName
              : this.state.userInfo.provider.providerName,
            phone: data.phone,
            state: data.state,
            websiteUrl: data.websiteUrl,
            zipcode: data.zipcode,
            primaryEmail: data.primaryEmail,
            primaryFirstName: data.primaryFirstName,
            primaryLastName: data.primaryLastName,
            primaryPhone: data.primaryPhone,
            providerAboutUs: data.providerAboutUs,
            userid: data.userLoginId,
            oldUserId: data.userLoginId,
            addressStreetValid: true,
            addressSuiteValid: true,
            cityValid: true,
            dateEstablishmentValid: true,
            emailValid: true,
            faxValid: true,
            orgNameValid: true,
            phoneValid: true,
            stateValid: true,
            websiteUrlValid: true,
            zipcodeValid: true,
            primaryEmailValid: true,
            primaryFirstNameValid: true,
            primaryLastNameValid: true,
            primaryPhoneValid: true,
            longitudeValid: true,
            latitudeValid: true,
            useridValid: true,
            longitude: data.longitude,
            latitude: data.latitude,
            isImported: data.isImported || false,
            // Organization media - use base64 fields for display
            organizationLogo: data.organizationLogoBase64 || null,
            organizationLogoUrl: data.organizationLogo || null,
            organizationBrochure: data.organizationBrochureBase64 || null,
            organizationBrochureUrl: data.organizationBrochure || null,
            organizationPictures: data.organizationPictures || [],
            isVerified: data.isVerified || false,
          });
        } else {
          this.setState({
            orgName: this.state.userInfo.provider.providerName,
            orgNameValid: true,
          });
        }
      })
      .catch((error) => {
        return response;
      });
  };

  // ======= Organization Media Methods =======

  // Logo upload
  handleLogoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!ALLOWED_LOGO_EXTENSIONS.includes(file.type)) {
      userService.showNotification({
        title: "Logo Upload",
        message: "Logo must be PNG, JPG, or SVG format",
        type: "danger",
      });
      return;
    }

    // Validate file size
    if (file.size > ALLOWED_LOGO_SIZE) {
      userService.showNotification({
        title: "Logo Upload",
        message: "Logo file size must be less than 5MB",
        type: "danger",
      });
      return;
    }

    this.setState({ logoUploading: true });

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(apiPath.organizationLogoUpload, {
        method: "POST",
        headers: generalMimeAuthTokenHeader(),
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        // Read the file locally as data URL to avoid S3 URL fetch
        const reader = new FileReader();
        reader.onload = (e) => {
          this.setState({
            organizationLogo: e.target.result,
            organizationLogoUrl: data.logoUrl
          });
        };
        reader.readAsDataURL(file);
        userService.showNotification({
          title: "Logo Upload",
          message: "Logo uploaded successfully",
          type: "success",
        });
      } else {
        userService.showNotification({
          title: "Logo Upload",
          message: data.message || "Failed to upload logo",
          type: "danger",
        });
      }
    } catch (error) {
      userService.showNotification({
        title: "Logo Upload",
        message: "Failed to upload logo",
        type: "danger",
      });
    } finally {
      this.setState({ logoUploading: false });
      if (this.logoInputRef.current) {
        this.logoInputRef.current.value = "";
      }
    }
  };

  handleLogoDelete = async () => {
    this.setState({ logoUploading: true });

    try {
      const response = await fetch(apiPath.organizationLogoDelete, {
        method: "DELETE",
        headers: generalAuthTokenHeader(),
      });

      if (response.ok) {
        this.setState({ organizationLogo: null });
        userService.showNotification({
          title: "Logo",
          message: "Logo deleted successfully",
          type: "success",
        });
      } else {
        userService.showNotification({
          title: "Logo",
          message: "Failed to delete logo",
          type: "danger",
        });
      }
    } catch (error) {
      userService.showNotification({
        title: "Logo",
        message: "Failed to delete logo",
        type: "danger",
      });
    } finally {
      this.setState({ logoUploading: false });
    }
  };

  // Pictures upload
  handlePicturesUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    const currentCount = this.state.organizationPictures.length;
    if (currentCount + files.length > MAX_GALLERY_IMAGES) {
      userService.showNotification({
        title: "Pictures Upload",
        message: `Maximum ${MAX_GALLERY_IMAGES} pictures allowed. You currently have ${currentCount} pictures.`,
        type: "danger",
      });
      return;
    }

    // Validate all files
    for (const file of files) {
      if (!ALLOWED_GALLERY_EXTENSIONS.includes(file.type)) {
        userService.showNotification({
          title: "Pictures Upload",
          message: `Invalid file type: ${file.name}. Only PNG, JPG, WEBP, or GIF allowed.`,
          type: "danger",
        });
        return;
      }
      if (file.size > ALLOWED_GALLERY_SIZE) {
        userService.showNotification({
          title: "Pictures Upload",
          message: `File too large: ${file.name}. Maximum size is 10MB per image.`,
          type: "danger",
        });
        return;
      }
    }

    this.setState({ picturesUploading: true });

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await fetch(apiPath.organizationPicturesUpload, {
        method: "POST",
        headers: generalMimeAuthTokenHeader(),
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        // Read each file locally as data URL to avoid S3 URL fetch
        const readFileAsDataUrl = (f) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(f);
          });

        const base64Results = await Promise.all(files.map(readFileAsDataUrl));

        // Merge returned picture metadata with local base64 data
        const picturesWithBase64 = data.pictures.map((pic, index) => ({
          ...pic,
          pictureBase64: base64Results[index] || null,
        }));

        this.setState((prevState) => ({
          organizationPictures: [...prevState.organizationPictures, ...picturesWithBase64],
        }));
        userService.showNotification({
          title: "Pictures Upload",
          message: `${data.count} picture(s) uploaded successfully`,
          type: "success",
        });
      } else {
        userService.showNotification({
          title: "Pictures Upload",
          message: data.message || "Failed to upload pictures",
          type: "danger",
        });
      }
    } catch (error) {
      userService.showNotification({
        title: "Pictures Upload",
        message: "Failed to upload pictures",
        type: "danger",
      });
    } finally {
      this.setState({ picturesUploading: false });
      if (this.picturesInputRef.current) {
        this.picturesInputRef.current.value = "";
      }
    }
  };

  handlePictureSelect = (pictureId) => {
    this.setState((prevState) => {
      const selectedPictureIds = prevState.selectedPictureIds.includes(pictureId)
        ? prevState.selectedPictureIds.filter((id) => id !== pictureId)
        : [...prevState.selectedPictureIds, pictureId];
      return { selectedPictureIds };
    });
  };

  handleDeleteSelectedPictures = async () => {
    const { selectedPictureIds } = this.state;
    if (selectedPictureIds.length === 0) {
      userService.showNotification({
        title: "Pictures",
        message: "Please select pictures to delete",
        type: "warning",
      });
      return;
    }

    this.setState({ picturesUploading: true });

    try {
      const response = await fetch(apiPath.organizationPicturesDelete, {
        method: "DELETE",
        headers: generalAuthTokenHeader(),
        body: JSON.stringify({ pictureIds: selectedPictureIds }),
      });

      const data = await response.json();

      if (response.ok) {
        this.setState((prevState) => ({
          organizationPictures: prevState.organizationPictures.filter(
            (pic) => !selectedPictureIds.includes(pic.id)
          ),
          selectedPictureIds: [],
        }));
        userService.showNotification({
          title: "Pictures",
          message: `${data.deletedCount} picture(s) deleted successfully`,
          type: "success",
        });
      } else {
        userService.showNotification({
          title: "Pictures",
          message: data.message || "Failed to delete pictures",
          type: "danger",
        });
      }
    } catch (error) {
      userService.showNotification({
        title: "Pictures",
        message: "Failed to delete pictures",
        type: "danger",
      });
    } finally {
      this.setState({ picturesUploading: false });
    }
  };

  // Drag and drop handlers for pictures
  handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      // Create a fake event to reuse the upload handler
      this.handlePicturesUpload({ target: { files } });
    }
  };

  // Brochure upload
  handleBrochureUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!ALLOWED_BROCHURE_EXTENSIONS.includes(file.type)) {
      userService.showNotification({
        title: "Brochure Upload",
        message: "Brochure must be PDF or image format (JPEG, PNG)",
        type: "danger",
      });
      return;
    }

    // Validate file size
    if (file.size > ALLOWED_BROCHURE_SIZE) {
      userService.showNotification({
        title: "Brochure Upload",
        message: "Brochure file size must be less than 20MB",
        type: "danger",
      });
      return;
    }

    this.setState({ brochureUploading: true });

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(apiPath.organizationBrochureUpload, {
        method: "POST",
        headers: generalMimeAuthTokenHeader(),
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        // Read the file locally as data URL to avoid S3 URL fetch
        const reader = new FileReader();
        reader.onload = (e) => {
          this.setState({
            organizationBrochure: e.target.result,
            organizationBrochureUrl: data.brochureUrl
          });
        };
        reader.readAsDataURL(file);
        userService.showNotification({
          title: "Brochure Upload",
          message: "Brochure uploaded successfully",
          type: "success",
        });
      } else {
        userService.showNotification({
          title: "Brochure Upload",
          message: data.message || "Failed to upload brochure",
          type: "danger",
        });
      }
    } catch (error) {
      userService.showNotification({
        title: "Brochure Upload",
        message: "Failed to upload brochure",
        type: "danger",
      });
    } finally {
      this.setState({ brochureUploading: false });
      if (this.brochureInputRef.current) {
        this.brochureInputRef.current.value = "";
      }
    }
  };

  handleBrochureDelete = async () => {
    this.setState({ brochureUploading: true });

    try {
      const response = await fetch(apiPath.organizationBrochureDelete, {
        method: "DELETE",
        headers: generalAuthTokenHeader(),
      });

      if (response.ok) {
        this.setState({ organizationBrochure: null });
        userService.showNotification({
          title: "Brochure",
          message: "Brochure deleted successfully",
          type: "success",
        });
      } else {
        userService.showNotification({
          title: "Brochure",
          message: "Failed to delete brochure",
          type: "danger",
        });
      }
    } catch (error) {
      userService.showNotification({
        title: "Brochure",
        message: "Failed to delete brochure",
        type: "danger",
      });
    } finally {
      this.setState({ brochureUploading: false });
    }
  };

  isBrochureImage = () => {
    const brochure = this.state.organizationBrochure;
    if (!brochure) return false;
    if (brochure.startsWith("data:image/")) return true;
    const lower = brochure.toLowerCase();
    return lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".png");
  };

  getBrochureFileName = () => {
    if (!this.state.organizationBrochure) return "";
    const url = this.state.organizationBrochure;
    // Handle base64 data URLs
    if (url.startsWith("data:")) {
      return this.isBrochureImage() ? "Organization_Brochure" : "Organization_Brochure.pdf";
    }
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  handleViewBrochure = () => {
    const brochureData = this.state.organizationBrochure;
    if (!brochureData) return;

    // If it's a base64 data URL, convert to Blob and open
    if (brochureData.startsWith("data:")) {
      // Extract base64 content
      const base64Content = brochureData.split(",")[1];
      const mimeType = brochureData.split(";")[0].split(":")[1];

      // Convert base64 to Blob
      const byteCharacters = atob(base64Content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });

      // Create object URL and open in new tab
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } else {
      // If it's a regular URL (S3 URL), open directly
      window.open(brochureData, "_blank", "noopener,noreferrer");
    }
  };

  // ======= End Organization Media Methods =======

  render() {
    const { classes } = this.props;
    return (
      <div className="front-modal">
        {this.state.loading ? <LinearProgress color="primary" /> : ""}
        {/* Organization Logo Section */}
        <Box display="flex" alignItems="center" mb={3}>
          <Box
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              backgroundColor: "#e0e0e0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              marginRight: "20px",
            }}
          >
            {this.state.organizationLogo ? (
              <img
                src={this.state.organizationLogo}
                alt="Organization Logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <span style={{ fontSize: "32px", color: "#999" }}>🏢</span>
            )}
          </Box>
          <Box className="g-organization-logo-box">
            <div className="g-organization-logo-label">Organization Logo</div>
            <input
              type="file"
              ref={this.logoInputRef}
              onChange={this.handleLogoUpload}
              accept="image/png,image/jpeg,image/jpg,image/svg+xml"
              style={{ display: "none" }}
            />
            <Box display="flex" alignItems="center" mb={1}>
              <Button
                variant="contained"
                size="small"
                onClick={() => this.logoInputRef.current.click()}
                disabled={this.state.logoUploading}
                style={{ backgroundColor: "#F07DA8", color: "#FFFFFF", marginRight: "10px", textTransform: "none" }}
                startIcon={this.state.logoUploading ? <CircularProgress size={16} color="inherit" /> : <CloudUploadIcon />}
                className="g-btn1 save-btn"
              >
                Upload logo
              </Button>
              {this.state.organizationLogo && (
                <Button
                  variant="outlined"
                  size="small"
                  className="g-btn1"
                  onClick={this.handleLogoDelete}
                  disabled={this.state.logoUploading}
                  style={{ textTransform: "none", backgroundColor: "#E6E6E6", border: "none"}}
                >
                  Remove
                </Button>
              )}
            </Box>
            <div style={{ fontSize: "12px", color: "#666" }}>
              Upload your organization's official logo (PNG, JPG, or SVG)
            </div>
          </Box>
        </Box>
        <form onSubmit={this.handleSubmit} noValidate>
          {/* Row 1: Name of Organisation + Date of Birth */}
          <Box display="flex" flexDirection="row" width={1} mt={2} className="org-form-cover" style={{ gap: "20px" }}>
            <Box flex={3}>
              <TextField
                name="orgName"
                value={this.state.orgName}
                label="Name of Organisation"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="1"
              />
              <FormErrors
                show={!this.state.orgNameValid}
                formErrors={this.state.formErrors}
                fieldName="orgName"
              />
            </Box>
            <Box flex={1}>
              <FormControl className="dateEstablished" fullWidth>
                <MuiPickersUtilsProvider utils={DateFnsUtils} moment={moment}>
                  <KeyboardDatePicker
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="start-date-picker-dialog"
                    InputLabelProps={{
                      className: "required-label",
                    }}
                    name="dateEstablishment"
                    value={this.state.dateEstablishment}
                    label="Date of Birth"
                    onChange={this.handleEstDate}
                    animateYearScrolling={true}
                    onError={this.handleEstDateError}
                    className="KeyboardDatePicker"
                    invalidDateMessage={enMsg.invalidDate}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                      className: "date-picker-span",
                    }}
                    tabIndex="6"
                    style={{ marginTop: 0 }}
                  />
                </MuiPickersUtilsProvider>
                <FormErrors
                  show={!this.state.dateEstablishmentValid}
                  formErrors={this.state.formErrors}
                  fieldName="dateEstablishment"
                />
              </FormControl>
            </Box>
          </Box>

          {/* Organization Details Heading */}
          <div className="tab-heading tab-heading-text" style={{ marginTop: "20px" }}>Organization Details</div>
          <div className="service-info-text">
            <p>
              Please enter your organization's details. This is to shown to discharge
              planners and may also be sent to patients and/or their families.
            </p>
          </div>

          {/* Row 2: Address Street + Address Suite # */}
          <Box display="flex" flexDirection="row" width={1} mt={2} style={{ gap: "20px" }}>
            <Box flex={2}>
              <TextField
                name="addressStreet"
                value={this.state.addressStreet}
                label="Address Street"
                onChange={this.handleChangeInput}
                inputRef={this.addressStreetInputRef}
                fullWidth
                tabIndex="2"
              />
              <FormErrors
                show={!this.state.addressStreetValid}
                formErrors={this.state.formErrors}
                fieldName="addressStreet"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="addressSuite"
                value={this.state.addressSuite}
                label="Address Suite #"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="11"
              />
              <FormErrors
                show={!this.state.addressSuiteValid}
                formErrors={this.state.formErrors}
                fieldName="addressSuite"
              />
            </Box>
          </Box>

          {/* Row 3: City, State, Zipcode, Latitude, Longitude */}
          <Box display="flex" flexDirection="row" width={1} mt={2} style={{ gap: "20px" }}>
            <Box flex={1}>
              <TextField
                name="city"
                value={this.state.city}
                InputLabelProps={{ className: "required-label" }}
                label="City"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="3"
              />
              <FormErrors
                show={!this.state.cityValid}
                formErrors={this.state.formErrors}
                fieldName="city"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="state"
                value={this.state.state}
                InputLabelProps={{ className: "required-label" }}
                label="State"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="4"
              />
              <FormErrors
                show={!this.state.stateValid}
                formErrors={this.state.formErrors}
                fieldName="state"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="zipcode"
                value={this.state.zipcode}
                InputLabelProps={{ className: "required-label" }}
                label="Zipcode"
                onChange={this.handleZipCodeInput}
                fullWidth
                tabIndex="5"
              />
              <FormErrors
                show={!this.state.zipcodeValid}
                formErrors={this.state.formErrors}
                fieldName="zipcode"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="latitude"
                value={this.state.latitude}
                label="Latitude"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="5"
                disabled={true}
              />
              <FormErrors
                show={!this.state.latitudeValid}
                formErrors={this.state.formErrors}
                fieldName="latitude"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="longitude"
                value={this.state.longitude}
                label="Longitude"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="5"
                disabled={true}
              />
              <FormErrors
                show={!this.state.longitudeValid}
                formErrors={this.state.formErrors}
                fieldName="longitude"
              />
            </Box>
          </Box>

          {/* Row 4: Phone, Fax, Email, Website URL */}
          <Box display="flex" flexDirection="row" width={1} mt={2} style={{ gap: "20px" }}>
            <Box flex={1}>
              <TextField
                name="phone"
                value={this.state.phone}
                InputLabelProps={{ className: "required-label" }}
                label="Phone"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="7"
              />
              <FormErrors
                show={!this.state.phoneValid}
                formErrors={this.state.formErrors}
                fieldName="phone"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="fax"
                value={this.state.fax}
                label="Fax"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="8"
              />
              <FormErrors
                show={!this.state.faxValid}
                formErrors={this.state.formErrors}
                fieldName="fax"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="email"
                value={this.state.email}
                InputLabelProps={{ className: "required-label" }}
                label="Email"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="9"
              />
              <FormErrors
                show={!this.state.emailValid}
                formErrors={this.state.formErrors}
                fieldName="email"
              />
            </Box>
            <Box flex={1}>
              <TextField
                name="websiteUrl"
                value={this.state.websiteUrl}
                label="Website URL"
                onChange={this.handleChangeInput}
                fullWidth
                tabIndex="10"
              />
              <FormErrors
                show={!this.state.websiteUrlValid}
                formErrors={this.state.formErrors}
                fieldName="websiteUrl"
              />
            </Box>
          </Box>

          {/* About Us Section */}
          <Box width={1} mt={3}>
            <FormControl className="w-100">
              <TextField
                rows={4}
                multiline={true}
                fullWidth={true}
                name="providerAboutUs"
                placeholder="Briefly describe your organization (max 1000 characters)."
                label="About us"
                value={this.state.providerAboutUs}
                onChange={this.handleChangeInput}
                inputProps={{ maxLength: MAX_INPUT_LENGTH_LONG_TEXT }}
                className="comment-TextField"
              />
            </FormControl>
            <FormErrors
              show={!this.state.providerAboutUsValid}
              formErrors={this.state.formErrors}
              fieldName="providerAboutUs"
            />
          </Box>

          {/* Primary Contact of Organization */}
          <Box width={1} mt={4}>
            <div className="heading-line" style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "15px" }}>
              Primary Contact of Organization
            </div>
            <Box display="flex" flexDirection="row" width={1} style={{ gap: "20px" }}>
              <Box flex={1}>
                <TextField
                  name="primaryFirstName"
                  value={this.state.primaryFirstName}
                  InputLabelProps={{ className: "required-label" }}
                  label="First Name"
                  onChange={this.handleChangeInput}
                  fullWidth
                  tabIndex="12"
                />
                <FormErrors
                  show={!this.state.primaryFirstNameValid}
                  formErrors={this.state.formErrors}
                  fieldName="primaryFirstName"
                />
              </Box>
              <Box flex={1}>
                <TextField
                  name="primaryLastName"
                  value={this.state.primaryLastName}
                  InputLabelProps={{ className: "required-label" }}
                  label="Last Name"
                  onChange={this.handleChangeInput}
                  fullWidth
                  tabIndex="13"
                />
                <FormErrors
                  show={!this.state.primaryLastNameValid}
                  formErrors={this.state.formErrors}
                  fieldName="primaryLastName"
                />
              </Box>
              <Box flex={1}>
                <TextField
                  name="primaryEmail"
                  value={this.state.primaryEmail}
                  label="Email"
                  onChange={this.handleChangeInput}
                  fullWidth
                  tabIndex="14"
                />
                <FormErrors
                  show={!this.state.primaryEmailValid}
                  formErrors={this.state.formErrors}
                  fieldName="primaryEmail"
                />
              </Box>
              <Box flex={1}>
                <TextField
                  name="primaryPhone"
                  value={this.state.primaryPhone}
                  InputLabelProps={{ className: "required-label" }}
                  label="Phone"
                  onChange={this.handleChangeInput}
                  fullWidth
                  tabIndex="15"
                />
                <FormErrors
                  show={!this.state.primaryPhoneValid}
                  formErrors={this.state.formErrors}
                  fieldName="primaryPhone"
                />
              </Box>
            </Box>
          </Box>

          {/* Organization Pictures / Gallery Section */}
          {/* <Box width={1} mt={4} p={2} style={{ backgroundColor: "#fafafa", borderRadius: "8px", border: "1px solid #e0e0e0" }}> */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} style={{ marginTop: "24px" }}>
              <div style={{ fontWeight: "bold", color: "#000000" }}>
                Organization Pictures / Gallery
                <Tooltip title={this.state.selectedPictureIds.length === 0 ? "Select a picture to delete" : ""}>
                  <span style={{ marginLeft: "15px" }}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={this.handleDeleteSelectedPictures}
                      disabled={this.state.selectedPictureIds.length === 0 || this.state.picturesUploading}
                      style={{
                        backgroundColor: this.state.selectedPictureIds.length > 0 ? "#F07DA8" : "#ccc",
                        color: "white",
                        textTransform: "none",
                      }}
                      startIcon={<DeleteIcon />}
                    >
                      Delete{this.state.selectedPictureIds.length > 0 ? ` (${this.state.selectedPictureIds.length})` : ""}
                    </Button>
                  </span>
                </Tooltip>
              </div>
              <div style={{ fontSize: "12px", color: "#666" }}>
                {this.state.organizationPictures.length} / {MAX_GALLERY_IMAGES} images
              </div>
            </Box>

            <Box display="flex" flexWrap="wrap" gap={2}>
              {/* Drag and drop zone */}
              {this.state.organizationPictures.length < MAX_GALLERY_IMAGES && (
                <Box
                  onDragOver={this.handleDragOver}
                  onDrop={this.handleDrop}
                  onClick={() => this.picturesInputRef.current.click()}
                  style={{
                    width: "200px",
                    height: "180px",
                    border: "2px dashed #ccc",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    marginRight: "15px",
                    marginBottom: "15px",
                    padding: "8px",
                  }}
                >
                  {this.state.picturesUploading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <>
                      <CloudUploadIcon style={{ fontSize: "32px", color: "#999" }} />
                      <span style={{ fontSize: "12px", color: "#666", textAlign: "center", marginTop: "5px" }}>
                        Drag and drop here<br />or<br />
                        <span style={{ color: "#01A7A6" }}>Choose Images</span>
                      </span>
                      <span style={{ fontSize: "10px", color: "#999", marginTop: "5px" }}>
                        JPG or PNG (Max 10MB)
                      </span>
                    </>
                  )}
                </Box>
              )}

              {/* Hidden file input */}
              <input
                type="file"
                ref={this.picturesInputRef}
                onChange={this.handlePicturesUpload}
                accept="image/png,image/jpeg,image/jpg,image/webp,image/gif"
                multiple
                style={{ display: "none" }}
              />

              {/* Picture thumbnails */}
              {this.state.organizationPictures.map((picture) => (
                <Box
                  key={picture.id}
                  onClick={() => this.handlePictureSelect(picture.id)}
                  style={{
                    width: "200px",
                    height: "180px",
                    borderRadius: "8px",
                    overflow: "hidden",
                    position: "relative",
                    cursor: "pointer",
                    border: this.state.selectedPictureIds.includes(picture.id)
                      ? "3px solid #4caf50"
                      : "3px solid transparent",
                    marginRight: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <img
                    src={picture.pictureBase64 || picture.pictureUrl}
                    alt={picture.pictureName || "Organization picture"}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  {this.state.selectedPictureIds.includes(picture.id) && (
                    <Box
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        backgroundColor: "#4caf50",
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span style={{ color: "white", fontSize: "14px" }}>✓</span>
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          {/* </Box> */}

          {/* Organization Brochure Section */}
          {/* <Box width={1} mt={3} p={2} style={{ backgroundColor: "#fafafa", borderRadius: "8px", border: "1px solid #e0e0e0" }}> */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} style={{ marginTop: "24px" }}>
              <div style={{ fontWeight: "bold", color: "#000000" }}>
                Organization Brochure
                {this.state.organizationBrochure && (
                  <Button
                    variant="contained"
                    size="small"
                    onClick={this.handleBrochureDelete}
                    disabled={this.state.brochureUploading}
                    style={{ backgroundColor: "#F07DA8", color: "white", marginLeft: "15px", textTransform: "none" }}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </Button>
                )}
              </div>
            </Box>

            <Box display="flex" alignItems="center">
              {this.state.organizationBrochure ? (
                <Box
                  display="flex"
                  alignItems="center"
                  p={2}
                  style={{ backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #e0e0e0" }}
                >
                  {this.isBrochureImage() ? (
                    <img
                      src={this.state.organizationBrochure}
                      alt="Brochure"
                      style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "4px", marginRight: "10px" }}
                    />
                  ) : (
                    <PictureAsPdfIcon style={{ fontSize: "40px", color: "#f44336", marginRight: "10px" }} />
                  )}
                  <Box>
                    <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                      {this.getBrochureFileName()}
                    </div>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleViewBrochure();
                      }}
                      style={{ fontSize: "12px", color: "#4caf50", cursor: "pointer" }}
                    >
                      {this.isBrochureImage() ? "View Image" : "View PDF"}
                    </a>
                  </Box>
                </Box>
              ) : (
                <Box
                  onClick={() => this.brochureInputRef.current.click()}
                  style={{
                    width: "200px",
                    height: "180px",
                    border: "2px dashed #ccc",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                  }}
                >
                  {this.state.brochureUploading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <>
                      <PictureAsPdfIcon style={{ fontSize: "32px", color: "#999" }} />
                      <span style={{ fontSize: "12px", color: "#666", textAlign: "center", marginTop: "5px" }}>
                        Click to upload<br />PDF or image
                      </span>
                    </>
                  )}
                </Box>
              )}

              {/* Hidden file input */}
              <input
                type="file"
                ref={this.brochureInputRef}
                onChange={this.handleBrochureUpload}
                accept="application/pdf,image/jpeg,image/png"
                style={{ display: "none" }}
              />
            </Box>
          {/* </Box> */}

          <Box width={1} mt={3}>
            <Box
              className="form-button-cover form-actions"
              tabIndex="17"
            >
              {/* <div>
                <TextField
                  name="creationType"
                  value={this.state.isImported ? "Imported" : "Manual"}
                  label="Creation Type"
                  disabled={true}
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.isVerified}
                      onChange={this.handleVerifiedChange}
                      name="isVerified"
                      color="primary"
                    />
                  }
                  label="Verified"
                />
              </div> */}
              <Button
                className={this.state.loading ? "buttonSuccess btn1 g-btn1" : "btn1 g-btn1"}
                disabled={this.state.loading || !this.validateForm()}
                type="submit"
              >
                Save and Next
                {this.state.loading && (
                  <CircularProgress size={24} className="buttonProgress" />
                )}
              </Button>
              <Button className="back-btn btn2 g-btn1" type="button" tabIndex="18">
                <Link underline="none" to={providerBaseRoutes.dashboard.path}>
                  Cancel
                </Link>
              </Button>
            </Box>
          </Box>
        </form>
      </div>
    );
  }
}

OrganizationDetails.propTypes = {
  classes: PropTypes.object,
};
export default withStyles(styles)(OrganizationDetails);
